import React from 'react'

const CaseStudyRelatedStudies = (props) => {
    return (
        <div id="cs-association">
            <h4 className="casestudies">{i18njs["Resource.SimilarCaseStudies"]}</h4>

            {props.RelatedCaseStudies.map((e) => (
                <div className="cs-association-item" key={e}>
                    <a className="cs-inner-association-item" href={e.CsUrl}>
                        {e.CsImage != null && 
                            <div className="cs-association-item-image">
                                <img src={e.CsImage} alt={e.CsTitle} />
                            </div>
                        }
                        <div className="cs-association-item-content">
                            <p>{e.CsTitle}</p>
                        </div>
                    </a>
                </div>
            ))}
        </div>
    )
}

export default CaseStudyRelatedStudies